export default __webpack_public_path__ + "static/process-07-c06ee0abb8d65a9d27c68012a7340b9c.svg";